/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import SalesChannelTab from "./_components/SalesChannelTab";
import { useIntegrationData } from "../../apis/integrationApis";
import { useSearchParams } from "react-router-dom";
import NewApplication from "./_components/NewApplication";
import { usePermission } from "../../hooks/usePermissionTabs";

const Integration: React.FC = () => {
  const { allowed: canReadIntegration, isLoading: isPermissionLoading } =
    usePermission("integration", "read");
  const [searchParams, setSearchParams] = useSearchParams();
  const activeRole = searchParams.get("tab") || "All";

  const [searchFor, setSearchFor] = useState<string>("");
  const [value, setValue] = useState<string | undefined>("");
  const { data, isSuccess, isPending, refetch, isFetching } =
    useIntegrationData(
      1,
      searchFor,
      activeRole === "All" ? "" : activeRole?.toUpperCase(),
      value,
    );

  const [item, setItem] = useState(data);
  useEffect(() => {
    refetch();
  }, [activeRole, searchFor, value]);
  useEffect(() => {
    setItem(data);
  }, [isSuccess, data]);

  if (isPermissionLoading) {
    return (
      <div className="p-6 space-y-6 bg-[#F7F6F2]">
        <div className="bg-white rounded-xl p-6 h-64 bg-gray-100 rounded animate-pulse" />
      </div>
    );
  }

  if (!canReadIntegration) {
    return (
      <div className="p-6 space-y-6 bg-[#F7F6F2]">
        <div className="bg-white rounded-xl p-6 text-center text-gray-500">
          No access to any section.
        </div>
      </div>
    );
  }

  return (
    <div className="px-6 space-y-6">
      <div>
        {activeRole === "All" && (
          <div>
            <SalesChannelTab
              isPending={isPending}
              data={item}
              fetchData={refetch}
              tab={activeRole}
            />
          </div>
        )}
        {activeRole === "Sales" && (
          <div>
            <SalesChannelTab
              isPending={isPending}
              data={item}
              fetchData={refetch}
              tab={activeRole}
            />
          </div>
        )}
        {activeRole === "Shipping" && (
          <div>
            <SalesChannelTab
              isPending={isPending}
              data={item}
              fetchData={refetch}
              tab={activeRole}
            />
          </div>
        )}
        {activeRole === "Notification" && (
          <div>
            <SalesChannelTab
              isPending={isPending}
              data={item}
              fetchData={refetch}
              tab={activeRole}
            />
          </div>
        )}

        {activeRole === "New Applications" && <NewApplication />}
      </div>
    </div>
  );
};

export default Integration;
